module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/GalleryArrow.e4ce8f45.svg";